module.exports = __webpack_public_path__ + "static/image/main/pc/banner-3@2x.ver2_0_2.jpg?7b4207a2";